import { PiggyBank, ThermometerSun, HeartPulse, TrendingUp } from "lucide-react";
import { BENEFITS } from "../../data/content";
import { Reveal } from "../motion/Motion";

const ICONS = { PiggyBank, ThermometerSun, HeartPulse, TrendingUp };

export default function Benefits() {
  return (
    <section
      id="elonyok"
      data-testid="benefits-section"
      className="relative overflow-hidden bg-white py-20 md:py-32"
    >
      <div className="absolute inset-0 bg-grid opacity-60" />
      <div className="relative mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="mb-10 max-w-2xl md:mb-16">
          <Reveal>
            <p className="mb-5 flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] text-brand-accent">
              <span className="h-px w-10 bg-brand-accent" />
              Miért éri meg?
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-heading text-3xl font-extrabold leading-[1.08] tracking-tight text-brand-primary sm:text-4xl lg:text-5xl">
              A hőszigetelés, amely többszörösen megtérül
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 gap-px bg-brand-primary/10 sm:grid-cols-2 lg:grid-cols-4">
          {BENEFITS.map((b, i) => {
            const Icon = ICONS[b.icon];
            return (
              <Reveal key={b.title} delay={i * 0.08} className="bg-white">
                <div className="group flex h-full flex-col gap-5 bg-white p-8 transition-colors duration-300 hover:bg-brand-primary lg:p-10">
                  <Icon
                    size={44}
                    strokeWidth={1.5}
                    className="text-brand-accent transition-transform duration-300 group-hover:scale-110"
                  />
                  <h3 className="font-heading text-xl font-bold text-brand-primary transition-colors group-hover:text-white">
                    {b.title}
                  </h3>
                  <p className="text-sm leading-relaxed text-brand-primary/65 transition-colors group-hover:text-white/70">
                    {b.description}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
